import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import TableReport from '@componentes/TableReport';

function Sepultamento ({ lista }) {
  const headerListItens = [
    'Itens',
    'Usuário',
    'Descrição',
    'Peso Total',
    'Data do descarte'
  ];

  const [listaFormatada, setListaFormatada] = useState([]);

  function formatList (list) {
    const relatorioListaFormated = list.map(item => ({
      ...item,
      medicoResponsavelDescarte: item.medicoResponsavelDescarteId
        ? `${item.medicoResponsavelDescarteId} ${item.medicoResponsavelDescarte}`
        : ''
    }));
    setListaFormatada(relatorioListaFormated);
  }

  useEffect(() => {
    formatList(lista);
  }, [lista]);

  return (
    <TableReport
      title={'REGISTRO DE MATERIAIS DESCARTADOS PARA SEPULTAMENTO'}
      assinatura='Assinatura - CRM'
      headerList={headerListItens}
    >
      {listaFormatada.map((item, i) => (
        <tr key={i}>
          <td>{item.items}</td>
          <td>{item.usuarioLiberacao}</td>
          <td>{item.descricaoLote}</td>
          <td>{item.pesoTotal}</td>
          <td>{item.dataDescarte}</td>
        </tr>
      ))}
    </TableReport>
  );
}

Sepultamento.propTypes = {
  lista: PropTypes.array.isRequired
};

Sepultamento.defaultProps = {
  lista: []
};

export default Sepultamento;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/Lote/Sepultamento/index.js